import createSliders from '../../global/create-swiper-sliders';

function getSliderId(slider) {

    return slider.el.getAttribute('data-slider-id');
}

function getSlideSelectorButtons(sliderId) {

    return [...document.querySelectorAll(`[data-slide-selector-button-for-slider="${sliderId}"]`)];
}

function getSlideIndex(button) {
    const slideIndexAttribute = button.getAttribute('data-slide-index');
    
    return parseInt(slideIndexAttribute);
}

function selectSlide(button, slider) {
    const slideIndex = getSlideIndex(button);

    slider.slideTo(slideIndex);
}

function highlightActiveSlideSelectorButton(slider) {
    const sliderId = getSliderId(slider);
    const slideSelectorButtons = getSlideSelectorButtons(sliderId);
    
    slideSelectorButtons.filter(button => getSlideIndex(button) == slider.realIndex).forEach(button => button.classList.add('careersPortalTypes__slideSelectorButton--active'));

    slideSelectorButtons.filter(button => getSlideIndex(button) != slider.realIndex).forEach(button => button.classList.remove('careersPortalTypes__slideSelectorButton--active'));
}

function initSlideSelectorButtonNavigation(slider) {
    const sliderId = getSliderId(slider);
    const slideSelectorButtons = getSlideSelectorButtons(sliderId);

    slideSelectorButtons.forEach(button => button.addEventListener('click', e => selectSlide(button, slider)));

    slider.on('slideChange', slider => highlightActiveSlideSelectorButton(slider));
}

function init() {
    const options = {
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesProgress: true,
        freeMode: false,
    };

    const sliders = createSliders('js_careersPortalTypes__types', options);
    sliders.forEach(initSlideSelectorButtonNavigation);
    sliders.forEach(highlightActiveSlideSelectorButton);
}

$(document).ready(init);
